import { ProgressSpinner } from 'primereact/progressspinner';
export const loader = {
    Loadermd,
    Loaderlg,
    Smallloader  
};

function  Loadermd(){
   return(<ProgressSpinner style={{width: '40px', height: '40px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />);   
}

function  Loaderlg(){
    return(<ProgressSpinner style={{width: '60px', height: '60px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />);   
 }

function Smallloader(){
    return(
        <ProgressSpinner style={{width: '14px', height: '14px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
    );   
} 